import { FC } from 'react';
import {
  ReferenceField,
  CreateButton,
  Datagrid,
  EditButton,
  List,
  TextField,
  TopToolbar,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить чат" />
  </TopToolbar>
);

export const ChatList: FC = () => (
  <List title="Список чатов" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <TextField source="name" label="Имя" />
      <TextField source="api_type" label="Ресурс" />
      <TextField source="start_message" label="Стартовое сообщение" />
      <ReferenceField source="model_id" reference="models" label="Модель">
        <TextField source="name" />
      </ReferenceField>
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
